import Colors from '@root/joinroot.com/src/utils/colors';
import PropTypes from '@root/vendor/prop-types';

export default function WashingtonDC({
  dataToDisplay, onMouseMove, styles, percentChangeClassName,
}) {
  return (
    <g
      css={styles.stateGroup}
      data-state-id={'dc'}
      data-testid={'dc'}
      onMouseMove={onMouseMove}
      tabIndex={'-1'}
    >
      <g
        className={`state ${percentChangeClassName}`}
        css={styles.state}
      >
        <path
          d={'M801.8,253.8 l-1.1-1.6 -1-0.8 1.1-1.6 2.2,1.5z'}
        />
        <title>Washington D.C.</title>
        <circle
          cx={'801.3'}
          cy={'251.8'}

          opacity={'1'}
          r={'5'}
          stroke={`${Colors.white()}`}
          strokeWidth={'1.5'}
        />
      </g>
      <text
        css={[styles.mapText, styles.stateLabelWithLine]}
        transform={'translate(890.73 260.6)'}
      >
        <tspan x={0}>D.C.</tspan>
        {dataToDisplay.states && dataToDisplay.states.DC &&
          <tspan
            dy={'1.2em'}
            x={0}
          >
            {Math.round(dataToDisplay.states.DC['2020'].pctChange)}%
          </tspan>
        }
      </text>
      <path
        css={styles.labelLine}
        d={'M876.5,257.5l-75,-5'}
        transform={'translate(0, -0.4)'}
      />
    </g>
  );
}

WashingtonDC.propTypes = {
  dataToDisplay: PropTypes.object.isRequired,
  onMouseMove: PropTypes.func.isRequired,
  percentChangeClassName: PropTypes.string.isRequired,
  styles: PropTypes.object.isRequired,
};
